/* unplugin-vue-components disabled */import script from "./RoleSkillTree.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleSkillTree.vue?vue&type=script&setup=true&lang=js"

import "./RoleSkillTree.vue?vue&type=style&index=0&id=3f0fbea1&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f0fbea1"]])

export default __exports__